// utils/vendorMatchUtils.js

const specialCases = ["amazonfresh"];

export function normalizeVendorName(vendor) {
  if (!vendor) return "";
  let v = vendor.toLowerCase();

  // Remove 'the' prefix
  v = v.replace(/^the\s+/g, "");

  // Remove domain suffixes (optionally preceded by dot or dash)
  v = v.replace(/[-.]?(com|net|org|co|io|us|biz|info|online|store|shop|site|app|the)$/g, "");

  // Remove all non-alphanumeric characters
  v = v.replace(/[^a-z0-9#]/g, "");

  v = v.replace(/['’‘`]/g, "");
  v = v.replace(/[._\-\s]/g, "");

  return v;

}

function isInSpecialCase(name) {
  return specialCases.some((sc) => name.startsWith(sc));
}

// Updated to handle multiple vendors separated by '##' in bank vendor string
export function isVendorMatch(bankVendorNorm, productVendorNorm) {
  if (!bankVendorNorm) return false;
  // If bankVendorNorm contains multiple vendors separated by ##
  const bankVendors = bankVendorNorm.split(/##|#/).map((v) => v.trim()).filter(Boolean);
 
  return bankVendors.some((bNorm) => {
    if (bNorm === productVendorNorm) return true;
    if (isInSpecialCase(bNorm) && isInSpecialCase(productVendorNorm)) {
      return bNorm.includes(productVendorNorm) || productVendorNorm.includes(bNorm);
    }
    return false;
  });
}

export function matchBankOffersToProducts(products, banks) {
  const bankMap = {};
  const groupedBanks = {};

  for (const bank of banks) {
    if (!bank.vendor) continue;
    const norm = normalizeVendorName(bank.vendor);

    if (!groupedBanks[norm]) groupedBanks[norm] = [];
    groupedBanks[norm].push(bank);
  }

  for (const product of products) {
    if (!product.vendor || product.offerPrice === 0) continue;
    const pNorm = normalizeVendorName(product.vendor);

    const matches = [];
    for (const bNorm in groupedBanks) {
      if (isVendorMatch(bNorm, pNorm)) {
        matches.push(...groupedBanks[bNorm]);
      }
    }

    if (matches.length) {
      bankMap[product.id] = matches;
    }
  }

  return bankMap;
}

export const REWARD_MAP = {
  walmart: "Walmart Cash",
  cvs: "ExtraBucks Rewards",
  "cvspharmacy": "ExtraBucks Rewards",
  walgreens: "Walgreens Cash Rewards",
  target: "Target Circle Rewards",
  bestbuy: "My Best Buy Rewards",
};

// ✅ Helper to get vendor reward label
export function getRewardLabel(vendor, type = "cashback") {
  const normalized = normalizeVendorName(vendor);
  const mapped = REWARD_MAP[normalized];
  if (mapped) return mapped;

  return type === "rebate" ? "Rebate" : "Cashback";
}